export default __webpack_public_path__ + "static/media/tasbih.3bbdc724.svg";